import { cn } from "@/lib/utils";

export interface EmptyAreaProps extends React.HTMLAttributes<HTMLDivElement> {}

export function EmptyArea({ children, className, ...props }: EmptyAreaProps) {
    return (
        <div className={cn("flex h-[450px] shrink-0 items-center justify-center rounded-md border border-dashed", className)} {...props}>
            <div className="mx-auto flex max-w-[420px] flex-col items-center justify-center text-center">{children}</div>
        </div>
    );
}
